// extracted by mini-css-extract-plugin
export default {"paginationContainer":"Pagination_paginationContainer__3+S4W","pageText":"Pagination_pageText__8-Bmc","paginationIcons":"Pagination_paginationIcons__2133L"};